module.exports = __webpack_public_path__ + "static/media/loader-nexti.5ac8b0b3.gif";